/* @flow weak */
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';

import EventTrackingMixin from 'components/mixins/EventTrackingMixin';
import createChainedFunction from 'utils/createChainedFunction';

/**
 * This component wraps another component and adds click tracking
 * events that occur when the component is focused.
 */
const FocusEventTrigger = React.createClass({
  propTypes: {
    trackChildComponents: React.PropTypes.bool,
  },

  mixins: [
    EventTrackingMixin,
  ],

  getDefaultProps() {
    return {
      trackChildComponents: false,
    };
  },

  propagateOnFocus(event) {
    const node = ReactDOM.findDOMNode(this);
    if (event.target === node || this.props.trackChildComponents) {
      this.trackClick();
    }
  },

  render() {
    const child = React.Children.only(this.props.children);
    const onFocus = createChainedFunction(this.propagateOnFocus, child.props.onFocus);
    return React.cloneElement(child, Object.assign({}, this.props, child.props, {
      children: child.props.children,
      className: cx(child.props.className, this.props.className),
      onFocus: createChainedFunction(onFocus, this.props.onFocus),
    }));
  },
});

export default FocusEventTrigger;



// WEBPACK FOOTER //
// ./src/components/FocusEventTrigger.jsx